module.exports = __webpack_public_path__ + "static/media/construction.4806695d.jpg";